var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFour = function SvgFour(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3861 0H2.7194C1.25273 0 0.0527344 1.2 0.0527344 2.66667V21.3333C0.0527344 22.8 1.25273 24 2.7194 24H21.3861C22.8527 24 24.0527 22.8 24.0527 21.3333V2.66667C24.0527 1.2 22.8527 0 21.3861 0ZM14.7194 18.6667C13.9861 18.6667 13.3861 18.0667 13.3861 17.3333V13.3333H9.38607C8.65273 13.3333 8.05273 12.7333 8.05273 12V6.66667C8.05273 5.93333 8.65273 5.33333 9.38607 5.33333C10.1194 5.33333 10.7194 5.93333 10.7194 6.66667V10.6667H13.3861V6.66667C13.3861 5.93333 13.9861 5.33333 14.7194 5.33333C15.4527 5.33333 16.0527 5.93333 16.0527 6.66667V17.3333C16.0527 18.0667 15.4527 18.6667 14.7194 18.6667Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFour, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/four.a26d1876.svg";
export { ForwardRef as ReactComponent };